import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { SidebarContent } from "@/components/layout/AppShell";

// The only permitted sheet in the app: the mobile navigation overlay sliding in from the LEFT.
export const MobileSidebar = ({ open, onOpenChange }) => (
  <Sheet open={open} onOpenChange={onOpenChange}>
    <SheetContent side="left" className="w-56 p-0" data-testid="mobile-sidebar">
      <SheetTitle className="sr-only">Navigation</SheetTitle>
      <SheetDescription className="sr-only">Main navigation menu</SheetDescription>
      <SidebarContent mobile onNavigate={() => onOpenChange(false)} />
    </SheetContent>
  </Sheet>
);
